import envHelper from "@/utils/env-helper"

class AppConfig {
  get env() {
    return envHelper.env || ""
  }

  get cookieNamePrefix() {
    return envHelper.cookieNamePrefix || "default_"
  }
}

export default new AppConfig()
